let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cDWNl")).then(() => parcelRequire('dX5iH'));